import type { SunProtectionOrderRole } from "@/models/order";

export type SunProtectionPageGate =
    | "placedOrder"
    | "measurementSigned"
    | "flow";

type GateInput = {
    role: SunProtectionOrderRole;
    hasSignature: boolean;
    isMeasurementSigned: boolean;
};

/**
 * Decides what a visitor sees when they (re)open the zonwering link
 * (THER-2244). Only customers are gated — the measurer and sales always keep
 * editing the flow. A placed order (the customer signed it) takes precedence
 * over a signed measurement, so a customer who ordered always lands on the
 * thank-you page even if the measurer visited afterwards.
 */
export function getSunProtectionPageGate({
    role,
    hasSignature,
    isMeasurementSigned,
}: GateInput): SunProtectionPageGate {
    if (role !== "CUSTOMER") return "flow";
    if (hasSignature) return "placedOrder";
    if (isMeasurementSigned) return "measurementSigned";
    return "flow";
}
